import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const InspectionReportView = lazy(async () => {
  const m = await import("@/features/inspections/components/inspection-report-view");
  return { default: m.InspectionReportView };
});

function InspectionReportPage() {
  const params = useParams({ from: "/_app/inspections/$inspectionId/report" });
  return (
    <Suspense fallback={null}>
      <InspectionReportView inspectionId={params().inspectionId} />
    </Suspense>
  );
}

export const inspectionReportRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/inspections/$inspectionId/report",
  component: InspectionReportPage,
});
